<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [formGroup]="dataForm" class="checklist">
  <label class="label" for="checklistItems">{{ label }}</label>

  <div
    formArrayName="checklistItems"
    class="checkbox-grid"
    [ngStyle]="{
      'grid-template-rows': 'repeat(' + getRows() + ', auto)',
      'grid-auto-flow': 'column',
      'grid-template-columns': 'repeat(' + columns + ', 1fr)'
    }"
  >
    <div *ngFor="let ctrl of checklistItemsArray.controls; let i = index">
      <mat-checkbox
        [formControlName]="i"
        (change)="checkboxChanged()"
        [disabled]="dataList[i].data?.disabled"
      >
        {{ dataList[i].text }}
      </mat-checkbox>
    </div>
  </div>
</div>
